import { useGPTStore } from '@/store';
import { Button, ScrollArea, Select, Text } from '@mantine/core';
import { DatasetsFilesInfo, refreshDatasetsFile, refreshDatasetsIntegrationFile } from '@mygpt/app';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const AdvancedTrainModal = ({
  datasetId,
  integrationRuleId,
  fileIds,
  onTrainSuccess,
  filesList,
}: {
  datasetId: string;
  integrationRuleId: string;
  fileIds: string[];
  onTrainSuccess: () => void;
  filesList: DatasetsFilesInfo[];
}) => {
  const { t } = useTranslation();

  const [model, setModel] = useState<string>('');
  const [trainLoading, setTrainLoading] = useState(false);
  const { configInfo } = useGPTStore();

  const modelList = configInfo?.advanced_parser
    .filter((item) => item.enabled)
    .filter((item) => item.value != 100) // onprem下，先从多模态学习列表中移除快速学习
    .map((item) => ({
      value: `${item.value}`,
      label: item.label,
    }));

  useEffect(() => {
    if (modelList && modelList.length > 0) {
      setModel(modelList[0].value);
    }
  }, []);

  const handleTrain = () => {
    setTrainLoading(true);
    if (integrationRuleId) {
      refreshDatasetsIntegrationFile({
        datasetId,
        fileIds,
        learn_type: Number(model),
        integration_rule_id: integrationRuleId,
      })
        .then(() => {
          onTrainSuccess();
        })
        .finally(() => {
          setTrainLoading(false);
        });
    } else {
      refreshDatasetsFile({ datasetId, fileIds, learn_type: Number(model) })
        .then(() => {
          onTrainSuccess();
        })
        .finally(() => {
          setTrainLoading(false);
        });
    }
  };

  return (
    <div>
      <div className="mt-3">
        <Text size="sm">{t('embeddings.documents.advanced_train.selected', { num: fileIds.length })}</Text>
        <div className="mt-2 py-2 rounded-lg border border-gray-200">
          <ScrollArea.Autosize className="max-h-[240px]">
            <div className="px-4">
              {fileIds.map((id, index) => {
                const file = filesList.find((f) => f.id === id);
                return (
                  <div key={id} className="py-1 text-gray-700 text-sm">
                    {index + 1}. {file?.filename || id}
                  </div>
                );
              })}
            </div>
          </ScrollArea.Autosize>
        </div>
      </div>

      <div className="mt-5">
        <Text size="sm">{t('embeddings.documents.advanced_train.train_model')}</Text>
        <Select
          size="sm"
          className="mt-2 w-full"
          data={modelList}
          value={model}
          allowDeselect={false}
          onChange={(value) => setModel(value || '1')}
        />
      </div>

      <div className="mt-6 flex justify-end">
        <Button loading={trainLoading} onClick={handleTrain}>
          {t('embeddings.documents.advanced_train.start_train')}
        </Button>
      </div>
    </div>
  );
};
